import { FSFileList, mapFSFileLists } from "../FileList";
import { FSDataOrder, mapFSDataOrder } from "../Order";
import { FSAccessory, mapFSAccessory } from "./Accessory";
import { FSAccessorySub, mapFSAccessorySub } from "./AccessorySub";

/* **************************************************** Finishing Shedule Accessory Data */
export interface FSAccessoryData {
    id: number;
    fs_data_id: number;
    category?: 'Light' | 'Door' | 'Paint' | 'Bathroom' | 'Kitchen' | 'Tiles' | 'Floor Finishing' | 'Others';
    accessory_name_id: number;
    accessory_sub_name_id: number | null;
    number: number;
    reference: string | null;
    link: string | null;
    image_path: string | null;
    file_list: FSFileList[];
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    accessory: FSAccessory | null;
    accessory_sub: FSAccessorySub | null;
}

export const mapFSAccessoryData = (data: any): FSAccessoryData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSAccessoryData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        category: data.category,
        accessory_name_id: data.accessory_name_id,
        accessory_sub_name_id: data.accessory_sub_name_id || null,
        number: data.number,
        reference: data.reference || null,
        link: data.link || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        order_status: data.order_status,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        accessory: data.accessory ? mapFSAccessory(data.accessory) : null,
        accessory_sub: data.accessory_sub ? mapFSAccessorySub(data.accessory_sub) : null,
    };

    return res;
};

export const mapFSAccessoryDatas = (data: any[]): FSAccessoryData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSAccessoryData);
};